import Vue from 'vue'
import VueRouter from 'vue-router'
import log from './middleware/log'
import authentication from './middleware/authentication'
/* Router for modules */
import agentRoutes from './modules/agent'
import callOutRoutes from './modules/callOut'
import CallMonitoringRoutes from './modules/callMonitoring'
import phoneAccountRoutes from './modules/phoneAccount'
import twilioPhoneNumberRoutes from './modules/twilioPhone'
import twilioSetting from './modules/twilioSetting'
import settingMain from './modules/settingMain'
import absenceResponseRoutes from './modules/absenceResponse'
import moment from 'moment'
import store from '@/store'
import companyResponseRoutes from './modules/companySetting'
import manageEndCallStatusRoutes from './modules/manageEndCallStatus'
import formPushLineMessagesResponseRoutes from './modules/formPushLineMessages'
import formSettingTextReplyResponseRoutes from './modules/formSettingTextReply'

const Login = () => import(/* webpackChunkName: "static/js/chunks/Login" */'../views/login/index')
const ForgotPassword = () => import(/* webpackChunkName: "static/js/chunks/ForgotPassword" */'../views/forgotPassword/index')
const ResetPassword = () => import(/* webpackChunkName: "static/js/chunks/ResetPassword" */'../views/resetPassword/index')
const Dashboard = () => import(/* webpackChunkName: "static/js/chunks/Dashboard" */'../views/Dashboard')
const CallList = () => import(/* webpackChunkName: "static/js/chunks/CallList" */'../views/CallList')
const ChangePassword = () => import(/* webpackChunkName: "static/js/chunks/ChangePassword" */'../views/ChangePassword')
const Calling = () => import(/* webpackChunkName: "static/js/chunks/Calling" */'../views/Calling')
const EndCall = () => import(/* webpackChunkName: "static/js/chunks/EndCall" */'../views/endCall/index')
const EndCallSecondary = () => import(/* webpackChunkName: "static/js/chunks/EndCallSecondary" */'../views/endCall/EndCallSecondary')
const NotPage = () => import('../views/NotPage/index')
const Monitoring = () => import(/* webpackChunkName: "static/js/chunks/Monitoring/index" */'../views/Monitor/index')
const ChatMessage = () => import(/* webpackChunkName: "static/js/chunks/chatMessage/Chat" */'../views/chatMessage/index')
const ChatMessageOld = () => import(/* webpackChunkName: "static/js/chunks/chatMessage/Chat" */'../views/chatMessage/old')
const LineChat = () => import(/* webpackChunkName: "static/js/chunks/lineChat/index" */'../views/lineChat/index')

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/notpage',
    component: NotPage,
    name: 'NotPage',
    hidden: true,
    meta: {
      role: 'notauthor',
      middleware: authentication
    }
  },
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    name: 'ForgotPassword',
    hidden: true
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    name: 'ResetPassword',
    hidden: true
  },
  {
    path: '/change-password',
    component: ChangePassword,
    name: 'ChangePassword',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  },
  {
    path: '/',
    component: Dashboard,
    name: 'Dashboard',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  },
  {
    path: '/monitoring',
    component: Monitoring,
    name: 'Monitoring',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  },
  {
    path: '/chat-message-old',
    component: ChatMessageOld,
    name: 'ChatMessageOld',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  },
  {
    path: '/chat-message',
    component: ChatMessage,
    name: 'ChatMessage',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  },
  {
    path: '/line-chat',
    component: LineChat,
    name: 'LineChat',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  },
  {
    path: '/call-list',
    component: CallList,
    name: 'CallList',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'main'
    }
  },
  {
    path: '/calling',
    component: Calling,
    name: 'Calling',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  },
  {
    path: '/end-call',
    component: EndCall,
    name: 'EndCall',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  },
  {
    path: '/end-call-secondary',
    component: EndCallSecondary,
    name: 'EndCallSecondary',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  },
  agentRoutes,
  ...callOutRoutes,
  ...phoneAccountRoutes,
  twilioPhoneNumberRoutes,
  ...twilioSetting,
  ...settingMain,
  ...CallMonitoringRoutes,
  absenceResponseRoutes,
  companyResponseRoutes,
  formPushLineMessagesResponseRoutes,
  formSettingTextReplyResponseRoutes,
  manageEndCallStatusRoutes,
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  const storage = localStorage.getItem('remember') ? localStorage : sessionStorage
  const tokenExpired = JSON.parse(storage.getItem('tokenExpired'))
  if (to.matched.some(record => record.meta.role === 'notauthor') && to.matched.some(record => !record.meta.middleware)) {
    // redirect page not found
    next(to)
  } else {
    if (storage.getItem('token') && to.matched.some(record => !record.meta.middleware) && (tokenExpired && tokenExpired > moment().valueOf())) {
      next({ name: 'Dashboard' })
    }
  }

  const userInfo = store.state.user.userInfo
  const userCompanyInfor = userInfo.company
  if (userInfo && !userInfo.configured && userCompanyInfor && !userCompanyInfor.disabled_phone) {
    if (to.matched.some(record => record.name !== 'TwilioSetup')) {
      next({ name: 'TwilioSetup', query: { alert: true } })
    }
    if (to.matched.some(record => !record.meta.middleware)) {
      storage.clear()
      next(to)
    }
  }

  const middleware = [log]
  if (middleware) {
    Array.isArray(to.meta.middleware) ? middleware.push(...to.meta.middleware) : middleware.push(to.meta.middleware)
  }

  const context = {
    from,
    next,
    router,
    to
  }
  const nextMiddleware = nextFactory(context, middleware, 1)

  return middleware[0]({ ...context, next: nextMiddleware })
})

// check redirect role
router.beforeEach((to, from, next) => {
  if ((to.path === '/' || to.path.includes('login')) && localStorage.getItem('currentPath')) {
    localStorage.removeItem('currentPath')
  } else {
    localStorage.setItem('currentPath', to.path)
  }
  const userInfor = store.state.user.userInfo
  const permissions = userInfor.role
  const company = userInfor.company

  if (!hasAccess(to.name) && permissions) {
    let isAcast = permissions.includes('a-cast')
    if (company) {
      isAcast = permissions.includes('a-cast') || company.can_chat
    }

    if (isAcast) {
      next({ name: 'ChatMessage' })
    } else {
      next({ name: 'NotPage' })
    }
  }

  return next()
})

function hasAccess(name) {
  if (store.state.user.userInfo) {
    const userInfor = store.state.user.userInfo
    const permissions = userInfor.role
    const roleCompany = userInfor.company && userInfor.company.role ? userInfor.company.role : null

    if (permissions) {
      switch (name) {
        case 'TwilioSetting':
          return !userInfor.company.disabled_phone && permissions.includes('admin')
        case 'AgentList':
          return permissions.includes('admin')
        case 'Acd':
          return !userInfor.company.disabled_phone && permissions.includes('admin')
        case 'ListTwilioPhoneNumber':
          return !userInfor.company.disabled_phone
        case 'AbsenceResponse':
          return !userInfor.company.disabled_phone && permissions.includes('admin')
        case 'ManageEndCallStatus':
          return !userInfor.company.disabled_phone && permissions.includes('admin')
        case 'CompanySetting':
          return !userInfor.company.disabled_phone && permissions.includes('admin') && roleCompany === 'kujira'
        case 'Monitoring':
          return !userInfor.company.disabled_phone
        case 'ListPhoneAccount':
          return !userInfor.company.disabled_phone
        case 'Dashboard':
          return !userInfor.company.disabled_phone
        case 'Dial':
          return !userInfor.company.disabled_phone
        case 'LineChat':
          return userInfor.company.can_chat_line
        case 'FormPushMessages':
          return userInfor.company.can_chat_line
        case 'FormSettingTextReply':
          return userInfor.company.can_chat_line && permissions.includes('admin')
        case 'ChatMessage':
          return permissions.includes('a-cast') || userInfor.company.can_chat
        case 'NotPage':
          return true
        default:
          return true
      }
    }
  }

  return false
}
export default router
